import { render, staticRenderFns } from "./commissioniDistributori.vue?vue&type=template&id=31fb070e&"
import script from "./commissioniDistributori.vue.ts?vue&type=script&lang=ts&"
export * from "./commissioniDistributori.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports